export default {
    loading: false,
    article: [],
    video: [],
}